import { useState, useEffect } from 'react';

const Footer = ({ onContactClick }) => {
  const footerWords = ['sharp', 'fresh', 'clean', 'right', 'sick'];
  const [wordIndex, setWordIndex] = useState(0);
  const [wordVisible, setWordVisible] = useState(true);
  const SQUIRE_BOOKING_URL = 'https://getsquire.com/booking/brands/bro-code-barbershop';
  useEffect(() => {
    const interval = setInterval(() => {
      setWordVisible(false);
      setTimeout(() => { setWordIndex(i => (i + 1) % footerWords.length); setWordVisible(true); }, 400);
    }, 2200);
    return () => clearInterval(interval);
  }, []);

  return (
    <footer className="footer">
      <div className="footer__top">
        <h2 className="footer__headline">
          You don't get a second chance to look{' '}
          <span style={{
            display: 'inline-block', opacity: wordVisible ? 1 : 0,
            transform: wordVisible ? 'translateY(0)' : 'translateY(16px)',
            transition: 'opacity 0.4s ease, transform 0.4s cubic-bezier(0.16,1,0.3,1)',
            color: 'var(--ripple)', fontStyle: 'italic',
          }}>{footerWords[wordIndex]}</span>{' '}
          — so get it right.
        </h2>
      </div>
      <div className="footer__grid">
        <div className="footer__col">
          <span className="footer__col-label">Navigate</span>
          <div className="footer__col-divider" />
          <ul className="footer__col-links">
            <li><a href="/#hero">Home</a></li>
            <li><a href="/#services">Services</a></li>
            <li><a href="/#locations">Locations</a></li>
            <li><a href="/gallery">Gallery</a></li>
            <li><a href="/team">Our Team</a></li>
          <li><a href="https://getsquire.com/booking/brands/bro-code-barbershop" onClick={() => {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-11480037647/YvQ4CIOw3I0cEI_yjeIq'
    });
  }}>Book Now</a></li>
            <li><a href="/admin">login</a></li>
          </ul>
        </div>
        <div className="footer__col">
          <span className="footer__col-label">Services</span>
          <div className="footer__col-divider" />
          <ul className="footer__col-links">
            <li><a href="/fades">Fades</a></li>
            <li><a href="/taper-fade">Taper Fade</a></li>
            <li><a href="/mens-haircuts">Men's Haircuts</a></li>
            <li><a href="/kids-haircuts">Kids' Haircuts</a></li>
            <li><a href="/beard-trim">Beard Trim</a></li>
            <li><a href="/tattoos">Tattoos</a></li>
          </ul>
        </div>
        <div className="footer__col">
          <span className="footer__col-label">Locations</span>
          <div className="footer__col-divider" />
          <ul className="footer__col-links">
            <li><a href="/barber-abbotsford">Barber in Abbotsford</a></li>
            <li><a href="/barber-surrey">Barber in Surrey</a></li>
          </ul>
        </div>
        <div className="footer__col">
          <span className="footer__col-label">Follow Us</span>
          <div className="footer__col-divider" />
          <ul className="footer__col-links">
            <li><a href="https://www.instagram.com/bro_code_barbershop/">@bro_code_barbershop</a></li>
          </ul>
        </div>
        <div className="footer__col">
          <span className="footer__col-label">Get In Touch</span>
          <div className="footer__col-divider" />
          <ul className="footer__col-links">
            <li><a href="mailto:brocodebarbers@icloud.com"> brocodebarbers@icloud.com</a></li>
          </ul>
        </div>
      </div>
      <div className="footer__bottom-divider" />
      <div className="footer__bottom">
        <span>© Copyright 2025 Brocode Barbershop — All rights reserved</span>
        <a href="https://ripplestrategies.ca/" rel="author" target="_blank" className="footer__credit">Website by Ripple Strategies</a>
        <span>Abbotsford · Surrey</span>
        <span className="footer__slash">WE'LL GET YOU RIGHT · BC'S BEST ///////////////////////////////////////////////////////////</span>
      </div>
      <div className="footer__wordmark">BRO{' '}CODE</div>
    </footer>
  );
};

export default Footer;
